import { render, staticRenderFns } from "./OrcamentoAcoesRegistro.vue?vue&type=template&id=42471ec1&scoped=true"
import script from "./OrcamentoAcoesRegistro.vue?vue&type=script&lang=js"
export * from "./OrcamentoAcoesRegistro.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoAcoesRegistro.vue?vue&type=style&index=0&id=42471ec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42471ec1",
  null
  
)

export default component.exports